// @ts-nocheck
(() => {
  const SECTION_SELECTOR = '.plp-product-grid[data-section-id]';
  const LOAD_MORE_BUTTON_SELECTOR = '[data-load-more-button]';

  const setLoadMoreLoadingState = (button, isLoading) => {
    const defaultLabel = button.dataset.defaultLabel || button.textContent.trim();
    const loadingLabel = button.dataset.loadingLabel || `${defaultLabel}...`;

    button.disabled = isLoading;
    button.dataset.loading = isLoading ? 'true' : 'false';
    button.textContent = isLoading ? loadingLabel : defaultLabel;
  };

  const appendLoadedProducts = (section, incomingSection) => {
    const currentList = section.querySelector('.plp-product-grid__list');
    const incomingList = incomingSection.querySelector('.plp-product-grid__list');

    if (!currentList || !incomingList) return false;

    const newItems = incomingList.querySelectorAll('.plp-product-grid__item');
    if (newItems.length === 0) return false;

    const fragment = document.createDocumentFragment();
    newItems.forEach((item) => fragment.appendChild(item));
    currentList.appendChild(fragment);
    return true;
  };

  const syncLoadMoreButton = (section, incomingSection) => {
    const currentWrapper = section.querySelector('.plp-product-grid__load-more');
    const currentButton = currentWrapper?.querySelector(LOAD_MORE_BUTTON_SELECTOR);
    const incomingButton = incomingSection.querySelector(LOAD_MORE_BUTTON_SELECTOR);

    if (!currentWrapper || !currentButton) return;

    if (!incomingButton) {
      currentWrapper.remove();
      return;
    }

    currentButton.dataset.nextPage = incomingButton.dataset.nextPage || '';
    currentButton.dataset.loadingLabel = incomingButton.dataset.loadingLabel || currentButton.dataset.loadingLabel || '';
    currentButton.dataset.defaultLabel = incomingButton.textContent.trim();
    currentButton.textContent = currentButton.dataset.defaultLabel;
    currentButton.disabled = false;
    currentButton.dataset.loading = 'false';
  };

  const fetchNextPageSection = async (section, nextPage) => {
    const sectionId = section.dataset.sectionId;
    if (!sectionId) return null;

    const requestUrl = new URL(window.location.href);
    requestUrl.searchParams.set('page', String(nextPage));
    requestUrl.searchParams.set('section_id', sectionId);

    const response = await fetch(requestUrl.toString(), {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (!response.ok) {
      throw new Error(`Failed to load more products: ${response.status}`);
    }

    const html = await response.text();
    const parser = new DOMParser();
    const documentNode = parser.parseFromString(html, 'text/html');
    return documentNode.querySelector(SECTION_SELECTOR) || documentNode.body;
  };

  const bindQuickAddButtons = (section) => {
    const quickAddButtons = section.querySelectorAll('.plp-product-grid__quick-add[data-variant-id]');

    quickAddButtons.forEach((button) => {
      if (button.dataset.quickAddBound === 'true') return;
      button.dataset.quickAddBound = 'true';

      button.addEventListener('click', async (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (button.disabled) return;

        const variantId = Number(button.dataset.variantId || '0');
        const quantity = Number(button.dataset.quantity || '1') || 1;
        if (!variantId) return;

        button.disabled = true;

        try {
          const payload = {
            items: [{
              id: variantId,
              quantity
            }]
          };

          const cartComponents = document.querySelectorAll('cart-items-component[data-section-id]');
          const sectionIds = Array.from(cartComponents)
            .map((component) => component.dataset.sectionId)
            .filter(Boolean);

          if (sectionIds.length > 0) {
            payload.sections = sectionIds.join(',');
            payload.sections_url = window.location.pathname + window.location.search;
          }

          const cartAddUrl = window.Theme?.routes?.cart_add_url || '/cart/add.js';
          const response = await fetch(cartAddUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify(payload)
          });

          const result = await response.json();
          if (result.status) {
            throw new Error(result.description || result.message || 'Add to cart failed');
          }

          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: result,
                sourceId: section.dataset.sectionId || 'plp-product-grid',
                data: {
                  source: 'product-form-component',
                  itemCount: quantity,
                  sections: result.sections || {}
                }
              }
            })
          );

          const drawer = document.querySelector('cart-drawer-component');
          if (drawer && typeof drawer.open === 'function') {
            drawer.open();
          } else {
            document.querySelector('[data-testid="cart-drawer-trigger"]')?.click();
          }
        } catch (error) {
          console.error(error);
        } finally {
          button.disabled = false;
        }
      });
    });
  };

  const bindLoadMoreButton = (section) => {
    const button = section.querySelector(LOAD_MORE_BUTTON_SELECTOR);
    if (!button || button.dataset.loadMoreBound === 'true') return;

    button.dataset.loadMoreBound = 'true';
    button.dataset.defaultLabel = button.textContent.trim();

    button.addEventListener('click', async (event) => {
      event.preventDefault();

      if (button.dataset.loading === 'true') return;

      const nextPage = Number(button.dataset.nextPage || '0');
      if (!nextPage) return;

      setLoadMoreLoadingState(button, true);

      try {
        const incomingSection = await fetchNextPageSection(section, nextPage);
        if (!incomingSection) return;

        const productsAppended = appendLoadedProducts(section, incomingSection);
        if (!productsAppended) {
          section.querySelector('.plp-product-grid__load-more')?.remove();
          return;
        }

        bindQuickAddButtons(section);
        syncLoadMoreButton(section, incomingSection);
      } catch (error) {
        console.error(error);
        setLoadMoreLoadingState(button, false);
      }
    });
  };

  const initSection = (section) => {
    if (section.dataset.plpProductGridInitialized === 'true') return;
    section.dataset.plpProductGridInitialized = 'true';

    bindQuickAddButtons(section);
    bindLoadMoreButton(section);
  };

  const init = () => {
    document.querySelectorAll(SECTION_SELECTOR).forEach((section) => initSection(section));
  };

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('theme:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
